<key-map-options-list 
    [options]="options"
    [compact]="compact$ | async">
</key-map-options-list>